import script from "./ToastContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastContainer.vue?vue&type=script&setup=true&lang=js"

import "./ToastContainer.vue?vue&type=style&index=0&id=c3a274c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a274c8"]])

export default __exports__